import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Injectable, inject} from '@angular/core';
import {ActionBarConfiguration} from './actionbarconfiguration';
import {FilterResult} from '../../resource/filterresult';
import {BaseApiService} from '../../core/services/base-api.service';
import {SupportedLocaleConfigurationService} from './supportedlocaleconfiguration.service';

@Injectable()
export class ActionBarConfigurationService extends BaseApiService {
  private localeService = inject(SupportedLocaleConfigurationService);

  public getActionBarConfigurations(): Observable<ActionBarConfiguration[]> {
    const attributes = [
      this.getAttr('DisplayName'),
      this.getAttr('Description'),
      this.getAttr('UsageKeyword'),
      this.getAttr('ButtonPosition'),
      this.getAttr('ButtonTheme'),
      this.getAttr('ButtonType'),
      this.getAttr('SiteType'),
      this.getAttr('LinkedObject'),
      this.getAttr('Order'),
      this.getAttr('UrlID'),
      this.getAttr('ActionBarResources'),
      this.getAttr('Icon'),
    ].filter(attr => attr !== null);

    return this.getWithLocale<FilterResult>(
      '/' + this.getType('ActionBarConfiguration'),
      attributes,
      10000,
      this.localeService.getSupportedLocaleConfiguration(),
    ).pipe(
      map(response => {
        let finalNavbars: ActionBarConfiguration[] = [];
        let navbars = this.toActionBarConfigurations(response.Results);
        navbars.forEach(obj => {
          let hasbrother: boolean = false;
          navbars.forEach(obj2 => {
            if (obj.displayname === obj2.displayname) {
              if (
                (obj.sitetype === 'wizard' && obj2.sitetype === 'batch') ||
                (obj.sitetype === 'batch' && obj2.sitetype === 'wizard') ||
                (obj.sitetype === 'wizard' && obj2.sitetype === 'batchlist') ||
                (obj.sitetype === 'batchlist' && obj2.sitetype === 'wizard') ||
                (obj.sitetype === 'approval' && obj2.sitetype === 'approvalbatch') ||
                (obj.sitetype === 'approvalbatch' && obj2.sitetype === 'approval')
              ) {
                hasbrother = true;
              }
            }
          });
          obj.hasbrother = hasbrother;
          finalNavbars.push(obj);
        });
        return finalNavbars;
      }),
    );
  }

  private toActionBarConfigurations(navbars: any): ActionBarConfiguration[] {
    let finalNavbars: ActionBarConfiguration[] = [];
    navbars.forEach(obj => {
      finalNavbars.push(this.toActionBarConfiguration(obj));
    });
    return finalNavbars;
  }

  private toActionBarConfiguration(r: any): ActionBarConfiguration {
    return <ActionBarConfiguration>{
      id: r[this.getAttr('ObjectID')],
      displayname: r[this.getAttr('DisplayName')],
      description: r[this.getAttr('Description')],
      usagekeyword: r[this.getAttr('UsageKeyword')],
      position: r[this.getAttr('ButtonPosition')],
      theme: r[this.getAttr('ButtonTheme')],
      type: r[this.getAttr('ButtonType')],
      sitetype: r[this.getAttr('SiteType')],
      urlid: r[this.getAttr('UrlID')],
      linkedobject: r[this.getAttr('LinkedObject')],
      order: r[this.getAttr('Order')],
      actionbarresources: r[this.getAttr('ActionBarResources')],
      icon: r[this.getAttr('Icon')],
    };
  }
}
